import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Breadcrumbs from 'components/layout/Breadcrumbs';
import TimeDate from 'components/shared/TimeDate';
import { Link, useLocation } from 'react-router-dom';
import { Col, Button } from 'reactstrap';
import { useSelector } from 'react-redux';
import AsyncSelect from 'react-select/async/dist/react-select.esm';
import Select from 'react-select';
import { userHasRole } from 'helpers/helpers';
import { loadClientsOptions } from '../../helpers/clients';
import {
  ROLES_ASEGURADO,
  ROLES_CORREDOR,
  STORAGE_CLIENT_KEY,
  STORAGE_CORREDOR_KEY,
  BASE_URL,
  API,
  ROLES_ASEGURADO_GARANTIA,
  ROLES_ASEGURADO_CREDITO,
  ROLES_CORREDOR_CREDITO,
  ROLES_CORREDOR_GARANTIA,
} from '../../CONST';
import { clientToOption } from '../../helpers/selects';

import auth from '../../helpers/auth';

const PageContainer = ({ children, breadcrumbs, returnTo, clientFilter, returnToFull, initialClient }) => {
  const user = useSelector((state) => state.login.user);
  const location = useLocation();
  const [client, setClient] = useState(() => {
    const clientFromState = location.state?.client;
    if (clientFromState) {
      sessionStorage.setItem(STORAGE_CLIENT_KEY, JSON.stringify(clientFromState));
      return clientFromState;
    }
    return JSON.parse(sessionStorage.getItem(STORAGE_CLIENT_KEY));
  });
  
  useEffect(() => {
    const clientFromState = location.state?.client;
    if (clientFromState) {
      sessionStorage.setItem(STORAGE_CLIENT_KEY, JSON.stringify(clientFromState));
      setClient(clientFromState);
    }
  }, [location.state?.client]);

  const clienteOption = clientToOption(client);
  const [corredor, setCorredor] = useState(
    JSON.parse(sessionStorage.getItem(STORAGE_CORREDOR_KEY)),
  );
  const corredorOption = clientToOption(corredor);
  const [clientesIntermediarioOptions, setClientesIntermediarioOptions] = useState([]);
  const colReturnProps = returnToFull ? { offset: 2, size: 10 } : { offset: 2, size: 8 };

  const handleClienteChange = (selectedOption) => {
    sessionStorage.setItem(STORAGE_CLIENT_KEY, JSON.stringify(selectedOption.value));
    setClient(selectedOption.value);
  };

  const handleCorredorChange = (selectedOption) => {
    sessionStorage.setItem(STORAGE_CORREDOR_KEY, JSON.stringify(selectedOption.value));
    setCorredor(selectedOption.value);
  };

  let clientToInject = client ? { ...client } : null;
  if (clientFilter && clientFilter.type === 'corredor') {
    clientToInject = corredor ? { ...corredor } : null;
  }

  const isIntermediary =
    userHasRole(user, ROLES_CORREDOR) &&
    !userHasRole(user, ROLES_ASEGURADO) &&
    !user.is_orsan &&
    clientFilter;

  useEffect(() => {
    if (isIntermediary) {
      const url = `${BASE_URL}${API.clientesIntermediario}/?ramo=${clientFilter.ramo}`;
      auth
        .fetch(url)
        .then((response) =>
          setClientesIntermediarioOptions(response.map((obj) => clientToOption(obj))),
        );
    }
  }, [isIntermediary]);

  const rolesAsegurado = {
    credito: ROLES_ASEGURADO_CREDITO,
    garantia: ROLES_ASEGURADO_GARANTIA,
    creditoGarantia: ROLES_ASEGURADO
  }
  const rolesCorredor = {
    credito: ROLES_CORREDOR_CREDITO,
    garantia: ROLES_CORREDOR_GARANTIA,
    creditoGarantia: ROLES_CORREDOR
  }
  return (
    <div>
      <TimeDate />
      <Breadcrumbs arrayMap={breadcrumbs} />
      {user.is_orsan && clientFilter && clientFilter.showFilter && (
        <div className="pl-3 mb-4" style={{ width: '450px', marginTop: '-1rem' }}>
          {clientFilter.type === 'asegurado' && (
            <AsyncSelect
              id="asegurado"
              name="asegurado"
              className="orsan-form-element z-index-4"
              loadOptions={(inputValue) => loadClientsOptions(
                inputValue,
                rolesAsegurado[clientFilter.ramo],
              )}
              defaultOptions
              cacheOptions
              value={clienteOption || null}
              onChange={handleClienteChange}
              placeholder="Seleccione Cliente"
            />
          )}
          {clientFilter.type === 'corredor' && (
            <AsyncSelect
              id="corredor"
              name="corredor"
              className="orsan-form-element z-index-4"
              loadOptions={(inputValue) => loadClientsOptions(
                inputValue,
                rolesCorredor[clientFilter.ramo],
              )}
              defaultOptions
              cacheOptions
              value={corredorOption || null}
              onChange={handleCorredorChange}
              placeholder="Seleccione Corredor"
            />
          )}
        </div>
      )}
      {isIntermediary && clientFilter && clientFilter.showFilter && (
        <div className="pl-3 mb-4" style={{ width: '450px', marginTop: '-1rem' }}>
          {clientFilter.type === 'asegurado' && (
            <Select
              name="asegurado"
              className="orsan-form-element z-index-4"
              defaultValue={clienteOption || null}
              options={clientesIntermediarioOptions}
              onChange={handleClienteChange}
              placeholder="Seleccione Cliente"
            />
          )}
        </div>
      )}

      {typeof children === 'function' ? children(clientToInject, handleClienteChange) : children}
      {returnTo && (
        <Col md={colReturnProps} style={{ marginTop: '20px', paddingRight: returnToFull ? '0px' : '' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
            <div style={{ gridColumnStart: 2 }}>
              <Link to={returnTo}>
                <Button
                  className="float-right"
                  color="orsan-secondary"
                  style={{ width: '150px', fontSize: '14px' }}
                >
                  Volver
                </Button>
              </Link>
            </div>
          </div>
        </Col>
      )}
      <div className="footer text-left">
        <div className="border-segments">
          <div className="segment" />
          <div className="segment" />
          <div className="segment" />
          <div className="segment" />
        </div>
        <div>
          {`© ${moment().year()} ORSAN. Encomenderos 113, Of. 801 Las Condes.`}
        </div>
      </div>
    </div>
  );
};

PageContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  breadcrumbs: PropTypes.arrayOf(PropTypes.object).isRequired,
  clientFilter: PropTypes.shape({
    type: PropTypes.oneOf(['asegurado', 'corredor', 'cliente']),
    ramo: PropTypes.oneOf(['credito', 'garantia', 'creditoGarantia']),
    showFilter: PropTypes.bool,
  }),
  returnTo: PropTypes.string,
  returnToFull: PropTypes.bool,
  initialClient: PropTypes.object,
};

PageContainer.defaultProps = {
  clientFilter: null,
  returnTo: null,
  returnToFull: false,
  initialClient: null
};

export default PageContainer;
